<template>
  <Modal :title="'Aggiungi appuntamento'" :openModal="open" @close="$emit('close')" @success="saveAppointment()" :loading="loadingSave" style="width: 100%; padding: 30px;">
    <div class="columns is-multiline">

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="field">
          <InputSelect
            name="Occupante"
            v-model="originalAppointment.occupant"
            :options="[]"
            :disabled="true"
            id="_id"
            track-by="_id"
            :custom-label="$clientName"
          >
            <a class="button is-warning" :href="originalAppointment.occupant ? '/clienti/'+originalAppointment.occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
          </InputSelect>
        </div>
      </div>

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <InputSelect
          name="Luogo"
          v-model="originalAppointment.place"
          :options="[]"
          :disabled="true"
          id="_id"
          track-by="_id"
          :custom-label="$placeName"
        >
          <a class="button is-warning" :href="originalAppointment.place ? '/luoghi/'+originalAppointment.place._id : 'javascript:void(0)'"><font-awesome-icon icon="building" class="m-0" /></a>
        </InputSelect>
      </div>

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <InputSelect
          name="Impianto"
          v-model="originalAppointment.implant"
          :options="[]"
          :disabled="true"
          id="_id"
          track-by="_id"
          :custom-label="$implantName"
        >
          <a class="button is-warning" :href="originalAppointment.implant ? '/impianti/'+originalAppointment.implant._id : 'javascript:void(0)'"><font-awesome-icon icon="temperature-arrow-up" class="m-0" /></a>
        </InputSelect>
      </div>
    </div>

    <WeekCalendar @newAppointment="appointments = [$event]" :canCreate="true" :canEdit="false" />
  </Modal>
</template>

<script>
export default {
  props: ['originalAppointment', 'open'],

  emits: ['saved', 'close'],

  data() {
    return {
      appointments: [],
      newOperation: {},
      loadingSave: false,

      type: null
    }
  },

  methods: {
    saveAppointment() {
      if (!this.appointments[0]) {
        alert('Non hai selezionato nulla dal calendario!')
        return
      }

      const self = this
      this.loadingSave = true

      this.newOperation = {
        client: this.originalAppointment.client?._id,
        occupant: this.originalAppointment.occupant?._id,
        place: this.originalAppointment.place?._id,
        implant: this.originalAppointment.implant?._id,
        revision: this.originalAppointment.revision,
        type: this.originalAppointment.type,
        reception_date: new Date().toDateInputValue(),
        implantCode: this.originalAppointment.implantCode,
        implantGenerators: this.originalAppointment.implantGenerators,
        linked_operation_prev: this.originalAppointment._id
      }

      this.newOperation.appointment_date = this.appointments[0].appointment_date,
      this.newOperation.appointment_start = this.appointments[0].appointment_start,
      this.newOperation.appointment_end = this.appointments[0].appointment_end,
      this.newOperation.operators = this.appointments[0].operators[0]

      this.$http.post('/operation', {...this.newOperation})
      .then(function (response) {
        const id_operation = response.data._id

        self.$http.put('/operation/' + self.originalAppointment._id, {linked_operation_next: id_operation}).then(() => {
          self.loadingSave = false
          self.$emit('saved', id_operation)
          self.newOperation = {}
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          self.loadingSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loadingSave = false
      })
    }
  }
}
</script>